<template>
  <div class="d-flex align-start ga-2">
    <v-text-field
      label="Discount Code"
      v-model="discountCode"
      :loading="loading"
      class="flex-grow-1"
      :error-messages="errors"
      @keyup.enter="handleAction"
    />
    <v-btn
      color="primary"
      :loading="loading"
      height="48"
      width="20%"
      @click="handleAction"
    >
      Apply
    </v-btn>
  </div>
</template>
<script setup lang="ts">
import { useEnv } from "@/composables/useEnv";
import {
  memberOrderSessionKey,
  type MemberOrderSession,
} from "@/composables/shop/useMemberOrder";

const env = useEnv();
const discountCode = ref<string>();
const balanceError = ref<string>();
const loading = ref(false);
const errors = computed(() => (balanceError.value ? [balanceError.value] : []));
const memberOrder = inject<MemberOrderSession | null>(
  memberOrderSessionKey,
  null,
);

async function handleAction() {
  if (env.mode !== "MEMBER") return;
  loading.value = true;
  try {
    if (!discountCode.value?.trim())
      throw new Error("Enter a discount code first.");
    if (!memberOrder?.canEdit.value)
      throw new Error("Load your open cart before applying a discount.");
    await memberOrder.applyCode(discountCode.value.trim());
    discountCode.value = "";
    balanceError.value = undefined;
  } catch (error) {
    balanceError.value =
      error instanceof Error ? error.message : "Unable to apply the code.";
  } finally {
    loading.value = false;
  }
}
</script>
